export default __webpack_public_path__ + "static/media/moleDAO.82533bc1.jpeg";